window.$ = jQuery;

var Program = require('./program.link/program.link');
var Navigation = require('./navigation/navigation');
var Header = require('./header/header');
var Banner = require('./banner/banner');
var BackTop = require('./back.top/top');

$(function(){
    new Program();
    new Navigation();
    new Header();
    new Banner();
    new BackTop();
});